import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import TeacherDashboard from "@/pages/TeacherDashboard";
import AssignmentDetail from "@/pages/AssignmentDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminManagement from "@/pages/AdminManagement";
import Planning from "@/pages/Planning";
import Etude from "@/pages/Etude";
import Appel from "@/pages/Appel";
import Rattrapages from "@/pages/Rattrapages";
import Mercredis from "@/pages/Mercredis";
import Signalements from "@/pages/Signalements";
import Sanctions from "@/pages/Sanctions";
import AppelsOverview from "@/pages/AppelsOverview";
import AdminSynthese from "@/pages/AdminSynthese";
import AdminProgressions from "@/pages/AdminProgressions";
import Timetables from "@/pages/Timetables";
import TeacherGroups from "@/pages/TeacherGroups";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--ink-soft)]">
        Chargement...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "direction" ? "/admin" : "/teacher"} replace />;
  }
  return children;
}

const TEACHER_ROLES = ["teacher", "assoc_admin"];
const ETUDE_ROLES = ["assoc_admin", "direction"];
const DIRECTION_ROLES = ["direction"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/teacher" element={<Protected roles={TEACHER_ROLES}><TeacherDashboard /></Protected>} />
            <Route path="/teacher/planning" element={<Protected><Planning /></Protected>} />
            <Route path="/teacher/appel" element={<Protected roles={TEACHER_ROLES}><Appel /></Protected>} />
            <Route path="/teacher/rattrapages" element={<Protected roles={TEACHER_ROLES}><Rattrapages /></Protected>} />
            <Route path="/teacher/groupes" element={<Protected roles={TEACHER_ROLES}><TeacherGroups /></Protected>} />
            <Route path="/teacher/signalements" element={<Protected roles={TEACHER_ROLES}><Signalements /></Protected>} />
            <Route path="/teacher/etude" element={<Protected roles={ETUDE_ROLES}><Etude /></Protected>} />
            <Route path="/teacher/assignment/:id" element={<Protected><AssignmentDetail /></Protected>} />
            <Route path="/admin" element={<Protected roles={DIRECTION_ROLES}><AdminDashboard /></Protected>} />
            <Route path="/admin/gestion" element={<Protected roles={DIRECTION_ROLES}><AdminManagement /></Protected>} />
            <Route path="/admin/mercredis" element={<Protected roles={DIRECTION_ROLES}><Mercredis /></Protected>} />
            <Route path="/admin/sanctions" element={<Protected roles={DIRECTION_ROLES}><Sanctions /></Protected>} />
            <Route path="/admin/appels" element={<Protected roles={DIRECTION_ROLES}><AppelsOverview /></Protected>} />
            <Route path="/admin/synthese" element={<Protected roles={DIRECTION_ROLES}><AdminSynthese /></Protected>} />
            <Route path="/admin/progressions" element={<Protected roles={DIRECTION_ROLES}><AdminProgressions /></Protected>} />
            <Route path="/emplois-du-temps" element={<Protected roles={ETUDE_ROLES}><Timetables /></Protected>} />
            <Route path="/admin/assignment/:id" element={<Protected roles={DIRECTION_ROLES}><AssignmentDetail /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
